// Replace this data with your actual projects from your Master's program
export const projects = [
  {
    id: 1,
    title: "Linux Shell and File System Navigator",
    description: "Custom shell implementation with process management, file system operations, and directory navigation. Implemented basic commands and shell scripting capabilities.",
    language: "C++",
    course: "Introduction to Software Development",
    technologies: ["C++", "Linux", "Shell Scripting", "Git"],
    github: "https://github.com/brandonmountan/linux-shell",
    demo: ""
  },
  {
    id: 2,
    title: "Java Audio Synthesizer with GUI",
    description: "Built a modular audio synthesizer in Java with JavaFX GUI featuring object-oriented AudioComponent architecture, implementing various signal generators and filters with real-time audio playback at 44.1 KHz, designing an interactive widget system with visual cable connections for routing audio between components, and utilizing bitwise operations for 16-bit sample manipulation.",
    language: "Java",
    course: "Computer Programming",
    technologies: ["Java", "JavaFX", "Object-Oriented Design", "Audio Processing"],
    github: "https://github.com/brandonmountan/audio-synthesizer",
    demo: ""
  },
  {
    id: 3,
    title: "Custom STL Vector Implementation",
    description: "Built a templated dynamic array container from scratch with automatic memory management, Rule of 3 implementation, operator overloading for array access and comparisons, 2x capacity growth strategy, and memory safety validation using address sanitizer.",
    language: "C++",
    course: "Data Structures and Algorithms",
    technologies: ["C++", "Templates", "Dynamic Memory Management", "Address Sanitizer"],
    github: "https://github.com/brandonmountan/custom-vector",
    demo: ""
  },
  {
    id: 4,
    title: "Automated Testing Framework",
    description: "Comprehensive testing suite with unit tests, integration tests, and continuous integration pipeline. Implemented code coverage analysis and automated test reporting.",
    language: "Java",
    course: "Software Engineering",
    technologies: ["Java", "JUnit", "Maven", "Jenkins", "Git"],
    github: "https://github.com/brandonmountan/testing-framework",
    demo: ""
  },
  {
    id: 5,
    title: "Custom Memory Allocator",
    description: "Efficient memory management system implementing malloc/free with optimization for performance. Includes defragmentation and memory pool management.",
    language: "C",
    course: "Systems 1 (Computer Arch + Operating Systems)",
    technologies: ["C", "Linux", "System Calls", "Memory Management"],
    github: "https://github.com/brandonmountan/memory-allocator",
    demo: ""
  },
  {
    id: 6,
    title: "Secure Chat Protocol",
    description: "End-to-end encrypted messaging system implementing custom security protocols. Features include RSA encryption, key exchange, and DDoS protection.",
    language: "C++",
    course: "Systems 2 (Computer Networks + Security)",
    technologies: ["C++", "TCP/IP", "OpenSSL", "Cryptography"],
    github: "https://github.com/brandonmountan/secure-chat",
    demo: ""
  },
  {
    id: 7,
    title: "E-Commerce Database System",
    description: "Relational database design for online retail with optimized queries. Implemented user authentication, product catalog, order management, and analytics dashboard.",
    language: "SQL",
    course: "Database Systems and Applications",
    technologies: ["PostgreSQL", "SQL", "Python", "NoSQL", "MongoDB"],
    github: "https://github.com/brandonmountan/ecommerce-db",
    demo: ""
  },
  {
    id: 8,
    title: "Character Classification and Image Denoising with Neural Networks",
    description: "Developed PyTorch-based CNNs for character classification and convolutional autoencoders for image denoising on UCI's character dataset, implementing data preprocessing pipelines, experimenting with network architectures (convolution layers, max pooling, dropout, batch normalization), and evaluating model generalization across multiple font types through cross-validation.",
    language: "Python",
    course: "Data Analytics, Visualization, and Machine Learning",
    technologies: ["Python", "PyTorch", "NumPy", "Pandas", "CNNs", "Autoencoders"],
    github: "https://github.com/brandonmountan/neural-networks-ml",
    demo: ""
  },
  {
    id: 9,
    title: "AI-Powered Task Management App",
    description: "Full-stack mobile and web application with AI recommendations. Features include cloud sync, intelligent task prioritization, and cross-platform support.",
    language: "JavaScript",
    course: "Application System Design and AI Integration",
    technologies: ["React", "React Native", "Node.js", "MongoDB", "REST APIs"],
    github: "https://github.com/brandonmountan/ai-task-manager",
    demo: ""
  },
  {
    id: 10,
    title: "Healthcare Analytics Platform",
    description: "Comprehensive data analytics platform for healthcare data visualization and prediction. Capstone project integrating ML models, secure databases, and interactive dashboards.",
    language: "Python",
    course: "MSD Capstone Project",
    technologies: ["Python", "React", "MongoDB", "Scikit-learn", "REST APIs"],
    github: "https://github.com/brandonmountan/healthcare-analytics",
    demo: ""
  }
];

// Personal information - update with your details
export const personalInfo = {
  name: "Brandon Mountan",
  title: "Software Developer",
  subtitle: "Master of Software Development",
  email: "brandonmountan1@gmail.com",
  github: "https://github.com/brandonmountan",
  linkedin: "https://linkedin.com/in/brandon-mountan-ab3063222",
  about: `I am a recent graduate of the Master of Software Development program at the University of Utah with a 
strong foundation in software engineering principles, algorithms, and full-stack development. With experience as 
a paramedic, I bring exceptional problem-solving abilities, critical decision-making under pressure, and strong 
collaboration skills to software development. I'm passionate about creating efficient, scalable solutions and 
continuously expanding my technical skill set.`
};

// Education information
export const education = [
  {
    degree: "Master of Software Development",
    university: "University of Utah",
    location: "Salt Lake City, UT",
    period: "2024 - December 2025",
    description: `Intensive graduate program covering software development fundamentals, data structures and algorithms, 
software engineering practices, systems programming (OS and networking), database systems, machine learning, 
and application design with AI integration. Completed with a comprehensive capstone project.`
  },
  {
    degree: "Bachelor of Science - Cell Biology and Neuroscience",
    university: "Montana State University-Bozeman",
    location: "Bozeman, MT",
    period: "Graduated May 2018",
    description: `Comprehensive undergraduate program in biological sciences with focus on cellular biology and neuroscience, 
developing strong analytical and research skills.`
  }
];

// Skills - customize these to match your expertise
export const skills = {
  languages: ["Python", "C/C++", "Java", "JavaScript", "C#", "Assembly", "SQL"],
  frameworks: ["React", "Node.js", "PyTorch", "JavaFX", "NumPy", "Pandas"],
  tools: ["GitHub", "MongoDB", "REST APIs", "Linux", "Git", "Docker"]
};